import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import data from "../../../../../../Json/Language/English";
import hindiDatas from "../../../../../../Json/Language/Hinid";
// import "../../../../StyleSheet/Mainstylesheet/Salary/PaySlip/PaySlip.scss";
import { useNavigate } from "react-router-dom";
import HeadingComp from "../../../UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import { settheGrievenceGetListForEMpActions } from "../../../../../../Redux/Slice";
import useLanguageSelector from "../../../UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import ReactTable from "../../../../../AppComponent/Table";
import _, { values } from "lodash";
import approved from "../../../../../../Assets/MainComponent/approved.svg";
import declined from "../../../../../../Assets/MainComponent/decline.svg";
import pending from "../../../../../../Assets/MainComponent/pending.svg";
import BackImage from "../../../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import GrievanceApplyEmp from "./GrievanceApplyEmp";



const GrievanceEMp = () => {
  const EnglishData = data;
  const HindiData = hindiDatas;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [createEditPopup, setCreateEditPopup] = useState(false);
  const [editPayload, setEditPayload] = useState({});
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const FileterState = {
    status: ""
  }
  const [selectVal, SetSelectval] = useState(FileterState);
  const [OptionValues, setOptionvalues] = useState([{ value: "", label: "All" }]);
  const state = useSelector((state) => state)
  const [sno, setsno] = useState(0);

  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Rejected" },
    { value: "approved", label: "Approved" },
  ];
  const [search, setsearch] = useState("")

  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const responseData = useSelector(
    (state) => state.FetchReimbursementCall.fetchReimbursementFeedData
  );
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  useEffect(() => {
    if (createEditPopup == false) {
      const payload = {
        page_size: 20,
        page: dtpageindex,
        status: selectVal.status,
        search: search
      };
      dispatch(settheGrievenceGetListForEMpActions(payload));
    }
  }, [selectVal, dtpageindex, search, createEditPopup]);

  const ClearState = (counts) => {
    setOptionvalues({ value: "", label: "All" })
    SetSelectval({
      ...selectVal,
      status: "",

    });
  };

  const count = (Counts, values, sel, SelectedValues) => {
    setOptionvalues(SelectedValues)
    SetSelectval({
      ///Completed
      ...selectVal,
      status: SelectedValues.value
    });
  };

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  const columns =
    useMemo(
      () => [
        {
          Header: "S.NO",
          accessor: "",
          Cell: (row) => {
            console.log(row.row);
            console.log(sno);
            return <p>{Number(sno + row.row.index + 1)}</p>;
          },
        },
        {
          Header: "CATEGORY",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {row.row.original.grievance_type != null && row.row.original.grievance_type != undefined &&
                  row.row.original.grievance_type.grievance_type != null && row.row.original.grievance_type.grievance_type != "" ? (
                  <span >
                    {capitalizeFirstLetter(row.row.original.grievance_type.grievance_type)}
                  </span>
                ) : (
                  <span>{"Not mention"}</span>
                )}
              </>
            );
          },
        },
        {
          Header: "PURPOSE",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {row.row.original.purpose != null && row.row.original.purpose != undefined ? (
                  <span >
                    {capitalizeFirstLetter(row.row.original.purpose)}
                  </span>
                ) : (
                  <span>{"Not mention"}</span>
                )}
              </>
            );
          },
        },
        {
          Header: "APPLIED DATE",
          accessor: "",
          Cell: (row) => {
            const dateString = row.row.original.created_at;
            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;

            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <span>
                  {`${row.row.original.created_at.slice(0, 10)
                    //  + "  " + formattedTime
                    }`}
                </span>
              </>
            );
          },
        },
        {
          Header: "STATUS",
          accessor: "",
          Cell: (row) => {
            const originalString = row.row.original.status;
            const capitalizedString = capitalizeFirstLetter(originalString);

            return (
              <>
                {row.row.original.status != undefined ? (
                  <>
                    <img
                      src={
                        row.row.original.status == "approved"
                          ? approved
                          : row.row.original.status === "pending"
                            ? pending
                            : declined
                      }
                      alt="img"
                      width={"25px"}
                      height={"25px"}
                    />
                    &nbsp;
                    <span>
                      {row.row.original.status == "approved"
                        ? "Approved"
                        : row.row.original.status === "pending"
                          ? "Pending"
                          : "Decline"}
                    </span>
                  </>
                ) : (

                  <span>{"--"}</span>
                )}
              </>
            );
          },
        },
      ], [sno]
    );
  var ParamsObject = {
    page_size: 20,
    page: dtpageindex,
    status: selectVal.status,
    search: search
  }
  console.log(state.grievenceDatasEmp.Total_Count, "piasidopas poSIA s");

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>

        <div className="leaveWrapper">

          <div className="row">
            <div className="col-12 leaveHeading text-left">
              <h3>GRIEVANCE</h3>
            </div>
          </div>

          <div
            className="row Filters ButtonPrevious"
            style={{
              padding: "4px",
              margin: "0px",
              position: "relative",
              zIndex: "30",

              marginLeft: "-16px",
              marginRight: "0px",
            }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/employment");
                }}
              >
                <img className="PreviousPages" src={BackImage} />
                <span></span>

              </button>
            </div>
            <button
              className="customButton  ButtonCSS"
              onClick={() => {
                setCreateEditPopup(true);
              }}
              style={{ background: "#234492", color: "white" }}
            >
              Apply
            </button>
          </div>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-12 leaveSubHeading">
              <ReactTable
                data={state.grievenceDatasEmp.grievenceDatasForEmployee}
                datacount={state.grievenceDatasEmp.Total_Count}
                columns={columns}
                pagesize={pagesize}
                dtpagesize={20}
                dtpageindex={dtpageindex}
                pageindex={pageindex}
                Search={true}
                onPrevious={handlePrevious}
                onNextpage={handleNext}
                GotoEnteredPage={GotoEnteredPage}
                Filter={true}
                values={OptionValues}
                options={options}
                count={count}
                ClearState={ClearState}
                onChange={tochange}
                setsno={setsno}
                sno={sno}
                id={"spe"}

              />
            </div>
          </div>
        </div>
      </div>
      {createEditPopup == true && (
        <GrievanceApplyEmp
          show={createEditPopup}
          setShow={setCreateEditPopup}
          editPayload={editPayload}
          setEditPayload={setEditPayload}
          GetFilter={ParamsObject}
        />
      )}
    </>
  );
};

export default GrievanceEMp;
